import solutions from './solutions'

const dai = {
  solutions,
}

export default dai
